import { fetchActiveDeliveryOtpsFromTransporter, createOtpTransporter } from '../../api/deliveryOtps';
import { getItem, setItem } from '../../utils/localStorage';
import { DEFAULT_PICK_UP_LOCATION_ID_KEY } from '../../utils/constants';

const initialState = {
  activeDeliveryOtps: []
};

export const deliveryOtps = {
  state: initialState,
  reducers: {
    setActiveDeliveryOtps(state, activeDeliveryOtps) {
      return {
        ...state,
        activeDeliveryOtps
      };
    }
  },
  effects: {
    async fetchActiveDeliveryOtps() {
      try {
        const activeDeliveryOtps = await fetchActiveDeliveryOtpsFromTransporter();
        this.setActiveDeliveryOtps(activeDeliveryOtps);
      } catch (error) {
        // what to do?
      }
    },
    async setDefaultPickupLocation(locationId) {
      const defaultPickupLocationId = parseInt(getItem(DEFAULT_PICK_UP_LOCATION_ID_KEY));

      if (!defaultPickupLocationId) {
        setItem(DEFAULT_PICK_UP_LOCATION_ID_KEY, locationId);
      }
    },
    async createOtp(otpRequest, rootState) {
      const { defaultPickUpLocationId } = rootState.deliveryOtps;
      const createOtpFunction = createOtpTransporter;
      await createOtpFunction(otpRequest);
      await this.fetchActiveDeliveryOtps();
      if (!defaultPickUpLocationId) {
        await this.setDefaultPickupLocation(otpRequest.pickupLocation.id);
      }
    }
  }
};
